export const formatPhoneNumber = (phoneNumber: string): string => {
    // Remove non-numeric characters
    const cleaned: string = phoneNumber.replace(/\D/g, "");

    // US/Canada: +1 (XXX) XXX-XXXX
    if (cleaned.startsWith("1") && cleaned.length === 11) {
        return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
    }
    // Israel: +972-XX-XXX-XXXX
    else if (cleaned.startsWith("972") && cleaned.length === 12) {
        return `+972-${cleaned.slice(3, 5)}-${cleaned.slice(5, 8)}-${cleaned.slice(8)}`;
    }
    // UK: +44 XXXX XXXXXX or +44 XXX XXX XXXX
    else if (cleaned.startsWith("44")) {
        return cleaned.length === 12
            ? `+44 ${cleaned.slice(2, 6)} ${cleaned.slice(6)}`
            : `+44 ${cleaned.slice(2, 5)} ${cleaned.slice(5, 8)} ${cleaned.slice(8)}`;
    }
    // Generic fallback for unknown formats: +XX XXXX XXXX
    else if (cleaned.length > 4) {
        return `+${cleaned.slice(0, cleaned.length - 8)} ${cleaned.slice(-8, -4)} ${cleaned.slice(-4)}`;
    }

    // Return as is if not recognized
    return phoneNumber;
}